import { Visibility as ViewIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from '@mui/material';
import { TableSkeleton } from '../../../../components/TableSkeleton';
import useCenterStudents from '../../../../hooks/useCenterStudents';
import { useState } from 'react';

const CenterStudentsView = () => {
  const { students, isStudentsLoading } = useCenterStudents({ adminView: true });
  const [viewStudent, setViewStudent] = useState(null);

  if (isStudentsLoading) return <TableSkeleton />;

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Center Students
        </Typography>
        <Typography variant="body2" color="textSecondary">
          All student registrations submitted by center users
        </Typography>
      </Box>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow sx={{ '& th': { fontSize: '14px', fontWeight: 'bold' } }}>
              <TableCell>Photo</TableCell>
              <TableCell>Applicant Name</TableCell>
              <TableCell>Course</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Added By</TableCell>
              <TableCell>Admission Date</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.length > 0 ? students.map((s) => (
              <TableRow key={s._id} sx={{ '& td': { fontSize: '14px' } }}>
                <TableCell>
                  <Avatar src={s.photo?.url} alt={s.applicantName} sx={{ width: 36, height: 36 }} />
                </TableCell>
                <TableCell>
                  <Box>
                    <Typography fontWeight={600} fontSize={14}>{s.title} {s.applicantName}</Typography>
                    <Typography fontSize={12} color="textSecondary">{s.email}</Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip label={s.course || '—'} size="small" color="success" variant="outlined" />
                </TableCell>
                <TableCell>{s.mobile}</TableCell>
                <TableCell>
                  <Chip label={s.category} size="small" variant="outlined" />
                </TableCell>
                <TableCell>
                  <Typography fontSize={13}>{s.addedBy?.firstName} {s.addedBy?.lastName}</Typography>
                  <Typography fontSize={11} color="textSecondary">{s.addedBy?.email}</Typography>
                </TableCell>
                <TableCell>{s.dateOfAdmission ? new Date(s.dateOfAdmission).toLocaleDateString() : '—'}</TableCell>
                <TableCell align="right">
                  <IconButton color="info" size="small" onClick={() => setViewStudent(s)}>
                    <ViewIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No center students found.</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* View Dialog */}
      <Dialog open={!!viewStudent} onClose={() => setViewStudent(null)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ background: 'linear-gradient(to right, #454751d1, #6b6d75)', color: '#fff', py: 1.5 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography fontWeight={700}>Student Details</Typography>
            <IconButton sx={{ color: '#fff' }} onClick={() => setViewStudent(null)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          {viewStudent && (
            <Box>
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Avatar src={viewStudent.photo?.url} sx={{ width: 72, height: 72 }} />
                <Box>
                  <Typography fontWeight={700} fontSize={18}>{viewStudent.title} {viewStudent.applicantName}</Typography>
                  <Typography color="textSecondary" fontSize={14}>{viewStudent.email}</Typography>
                  <Chip label={viewStudent.course || '—'} size="small" color="success" variant="outlined" sx={{ mt: 0.5 }} />
                </Box>
              </Box>
              <Divider sx={{ mb: 2 }} />
              {[
                ['Guardian', viewStudent.guardianName],
                ['Mother', viewStudent.motherName],
                ['Relationship', viewStudent.relationship],
                ['Gender', viewStudent.gender],
                ['Date of Birth', viewStudent.dateOfBirth ? new Date(viewStudent.dateOfBirth).toLocaleDateString() : '—'],
                ['Date of Admission', viewStudent.dateOfAdmission ? new Date(viewStudent.dateOfAdmission).toLocaleDateString() : '—'],
                ['Batch', viewStudent.batch || '—'],
                ['Fees', `₹${viewStudent.fees}`],
                ['Mobile', viewStudent.mobile],
                ['Guardian Mobile', viewStudent.mobileGuardian],
                ['Aadhaar', viewStudent.aadhaarNumber],
                ['Education', viewStudent.education],
                ['Category', viewStudent.category],
                ['Address', viewStudent.address],
                ['State', viewStudent.state],
                ['District', viewStudent.district],
                ['Pin Code', viewStudent.pinCode],
                ['Added By', `${viewStudent.addedBy?.firstName || ''} ${viewStudent.addedBy?.lastName || ''}`],
              ].map(([label, value]) => (
                <Box key={label} display="flex" justifyContent="space-between" mb={1}>
                  <Typography fontSize={13} fontWeight={600} color="textSecondary" sx={{ minWidth: 140 }}>{label}</Typography>
                  <Typography fontSize={13} textAlign="right">{value}</Typography>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewStudent(null)} sx={{ fontSize: 14, color: '#454751d1' }}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CenterStudentsView;
